import { Check } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { Overline } from "@/components/site/primitives";
import ConceptTag from "@/components/site/ConceptTag";
import { AMENITIES } from "@/lib/content";

// Alternating image/content showcase for each RestPower space.
function Showcase({ a, index }) {
  const flip = index % 2 === 1;
  return (
    <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-16" data-testid={`amenity-${a.key}`}>
      <Reveal className={flip ? "lg:order-2" : ""} y={30}>
        <div className="relative overflow-hidden rounded-3xl border border-white/10 shadow-glow-sm">
          <img
            src={a.image}
            alt={`${a.label} concept — RestPower`}
            loading="lazy"
            className="aspect-[3/2] w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
          <ConceptTag className="absolute left-4 top-4" />
        </div>
      </Reveal>

      <Reveal delay={0.08} className={flip ? "lg:order-1" : ""}>
        <Overline>{a.label}</Overline>
        <h3 className="mt-4 font-display text-3xl font-light uppercase leading-[0.98] tracking-tight text-white md:text-4xl">
          {a.title}
        </h3>
        {a.tagline && <p className="mt-4 font-display text-lg text-rp-accent">{a.tagline}</p>}
        <p className="mt-4 max-w-md text-base leading-relaxed text-white/55">{a.text}</p>
        <ul className="mt-6 space-y-3">
          {a.points.map((pt) => (
            <li key={pt} className="flex items-start gap-3 text-sm text-white/70">
              <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-rp-accent" />
              {pt}
            </li>
          ))}
        </ul>
        {a.note && (
          <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.12em] text-white/35">{a.note}</p>
        )}
      </Reveal>
    </div>
  );
}

export default function AmenityShowcase() {
  return (
    <div className="space-y-20 md:space-y-28 lg:space-y-32">
      {AMENITIES.map((a, i) => (
        <Showcase key={a.key} a={a} index={i} />
      ))}
    </div>
  );
}
